import { h } from "../shared/safe";

const tabs: [string, string][] = [
  ["Overview", ""], ["Websites", "websites"], ["Drip feed", "drip"], ["Content", "content"], ["Business details", "facts"], ["Images", "media"], ["Links", "links"], ["Activity", "activity"],
];

export function clientWorkspaceNav(clientId: string, active: string, name = "Client"): HTMLElement {
  const id = encodeURIComponent(clientId);
  return h("nav", { class: "cp-cw-tabs", "aria-label": `${name} workspace` },
    ...tabs.map(([label, suffix]) => h("a", { href: suffix ? `#/clients/${id}/${suffix}` : `#/clients/${id}`, class: active === label ? "is-active" : "" }, label)),
  );
}
